// src/components/Footer.jsx
import React from "react";
import { Box, Text, Stack } from "@chakra-ui/react";

const Footer = () => {
  return (
    <Box py={6} mt={0}>
      <Stack align="center">
        <Text fontWeight="medium">
          © {new Date().getFullYear()} ECO PIPE COMPANY. All rights reserved.
        </Text>
      </Stack>
    </Box>
  );
};

export default Footer;
